import React, { useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";
const DISMISS_KEY = "oryyn_push_dismissed";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) output[i] = raw.charCodeAt(i);
  return output;
}

export default function PushPrompt() {
  const [visible, setVisible] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function check() {
      const supported =
        "serviceWorker" in navigator &&
        "PushManager" in window &&
        "Notification" in window;
      if (!supported) return;
      if (localStorage.getItem(DISMISS_KEY)) return;
      if (Notification.permission === "denied") return;
      try {
        const reg = await navigator.serviceWorker.register("/sw.js");
        const existing = await reg.pushManager.getSubscription();
        if (!cancelled && !existing) setVisible(true);
      } catch {
        /* SW registration failed — silently skip */
      }
    }
    check();
    return () => {
      cancelled = true;
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };

  const enable = async () => {
    setBusy(true);
    try {
      const { data } = await axios.get(`${API_URL}/push/vapid`);
      if (!data?.enabled || !data?.publicKey) {
        setBusy(false);
        dismiss();
        return;
      }
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        setBusy(false);
        if (permission === "denied") dismiss();
        return;
      }
      const reg = await navigator.serviceWorker.register("/sw.js");
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.publicKey),
      });
      await axios.post(`${API_URL}/push/subscribe`, { subscription: sub });
      setVisible(false);
    } catch {
      /* user cancelled or error — leave prompt for next time */
    }
    setBusy(false);
  };

  if (!visible) return null;

  return (
    <div className="push-prompt" role="dialog" aria-label="Enable notifications">
      <span className="push-prompt-icon" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.7 21a2 2 0 0 1-3.4 0" />
        </svg>
      </span>
      <span className="push-prompt-text">Get notified about new features &amp; updates</span>
      <button className="push-prompt-enable" onClick={enable} disabled={busy} type="button">
        {busy ? "…" : "Enable"}
      </button>
      <button className="push-prompt-close" onClick={dismiss} type="button" aria-label="Dismiss">
        ✕
      </button>
    </div>
  );
}
